import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';
import { useTable, usePagination, useGlobalFilter } from 'react-table';
import { Button, Table } from 'semantic-ui-react';
import { TotalPill } from '../../';
import { StyledCTACell } from '../style';

const Mobile = props => {
  const { data, total, searchFilter, placeholder } = props;
  const columns = React.useMemo(() => props.columns, []);

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    rows, // rows to get filtered total number

    // The rest of these things are super handy, too ;)
    pageCount,
    setPageSize,
    setGlobalFilter,
    state: { pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: 10
      }
    },
    useGlobalFilter,
    usePagination
  );

  const handleLoadMoreClick = () => {
    setPageSize(pageSize + 10);
  };

  // when searchFilter changes, trigger `setGlobalFilter`
  // filter is moved to keep the selected sorting
  useEffect(() => {
    setGlobalFilter(searchFilter);
  }, [searchFilter]);

  // reset the pageSize to original number
  useEffect(() => {
    setPageSize(10);
    setGlobalFilter(searchFilter);
  }, [data]);

  const renderTable = () => (
    <section className="container__inner">
      <Table striped selectable {...getTableProps()}>
        <Table.Body {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            return (
              <Table.Row {...row.getRowProps()}>
                {row.cells.map(cell => {
                  const Cell = cell.column.isCTA ? StyledCTACell : Table.Cell;
                  return (
                    <Cell {...cell.getCellProps()} key={uuidv4()}>
                      {cell.render('Cell')}
                    </Cell>
                  );
                })}
              </Table.Row>
            );
          })}
        </Table.Body>

        {page.length < data.length && (
          <Table.Footer>
            <Table.Row>
              <Table.Cell textAlign="center">
                <Button onClick={handleLoadMoreClick} secondary>
                  Load More
                </Button>
              </Table.Cell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </section>
  );

  // rows holds filtered data from `data` array
  const count = pageCount > 1 ? rows.length : page.length;
  return (
    <Fragment>
      {data && count > 0 && total !== count && (
        <TotalPill
          total={count}
          unit="Result"
          trail={<small>(out of {total})</small>}
        />
      )}
      {count > 0 ? renderTable() : placeholder}
    </Fragment>
  );
};

Mobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
      sortType: PropTypes.string,
      Cell: PropTypes.func
    })
  )
};

export default Mobile;
